import { decodePayload } from './decodePayload';

const TOKEN_NAME = 'accessToken';
const REFRESH_TOKEN_NAME = 'refreshToken';
const AUTHORIZATION_COOKIE_NAME = 'authorization';
const AUTH_COOKIE_DOMAIN = (window as any).REACT_APP_AUTH_COOKIE_DOMAIN;

const KEYCLOAK_ENDPOINT = (window as any).REACT_APP_OAUTH2_PROVIDER_REFRESH_ENDPOINT;
const KEYCLOAK_LOGOUT_ENDPOINT: string | undefined = KEYCLOAK_ENDPOINT?.replace('/token', '/logout');

export const getCookieByName = (name: string): string | undefined => {
    const cookies = document.cookie.split('; ');
    return cookies?.find(cookie => cookie.startsWith(`${name}=`))?.replace(`${name}=`, '') ?? undefined;
};

export const setCookieByName = (name: string, value: string) => {
    const { exp } = decodePayload(value);
    document.cookie = name + '=' + value + '; domain=' + AUTH_COOKIE_DOMAIN + '; path=/; expires=' + new Date(exp * 1000).toUTCString();
};

export const removeCookieByName = (name: string) => {
    document.cookie = name + '=' + '; domain=' + AUTH_COOKIE_DOMAIN + '; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};

export const getAuthToken = () => getCookieByName(TOKEN_NAME);
export const getRefreshToken = () => getCookieByName(REFRESH_TOKEN_NAME);

export const invalidateKeycloakSession = () => {
    const refreshToken = getRefreshToken();
    if (KEYCLOAK_LOGOUT_ENDPOINT && refreshToken) {
        fetch(KEYCLOAK_LOGOUT_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                client_id: 'buszrent-crm',
                refresh_token: refreshToken,
            }),
        }).catch(() => {});
    }
};

export const removeAllAuthCookies = () => {
    removeCookieByName(TOKEN_NAME);
    removeCookieByName(REFRESH_TOKEN_NAME);
    removeCookieByName(AUTHORIZATION_COOKIE_NAME);
};

const KEYCLOAK_USERINFO_ENDPOINT: string | undefined = KEYCLOAK_ENDPOINT?.replace('/token', '/userinfo');

export { TOKEN_NAME, REFRESH_TOKEN_NAME, KEYCLOAK_ENDPOINT, KEYCLOAK_USERINFO_ENDPOINT };
